export default __webpack_public_path__ + "static/media/img2.8e748174.jpg";